import { ProjectState } from './types';

export const initialState: ProjectState = {
  draft: null,
  loadingDraftProject: false,
  updatingDraftProject: false,
  loadingDraftProjectError: null,
  isCreatingProjectFromDraft: false,
  createProjectErrors: null,
  workingProject: null,
  loadingWorkingProject: false,
  loadingWorkingProjectError: null,
  savingWorkingProject: false,
  savingWorkingProjectError: {},
  projectPublishedStatus: null,
  checkingPublishedStatus: false,
  updatingWorkingProject: false,
  deletingSession: false,
  previewTemplate: null,
  activePreviewPageTab: null,
  loadingPreviewTemplate: false,
  loadingPreviewTemplateError: null,
  updatedSessionUuid: null,
  sessionsToUpdateAfterProjectSave: null,
  projectGroups: null,
  settingUpProjectPreview: false,
  isSettingsUpdating: false,
  currentPostRegisterPage: null,
  displayEditProjectThemeTray: false,
  displayPreviewTemplateThemeTray: false,
  saveId: null,
  showUpdateProjectTypeModal: null,
  publishingProject: false,
  scheduledEmails: null,
  loadingScheduledEmails: false,
  selectEditOrPublishButtonState: 'editor',
  showUneditedContent: false,
  previewTemplateOverrides: {
    themeMode: null,
    themePack: null,
  },
  duplicatingSession: false,
  isCreatingNewSession: false,
  refetchProjectAfterSave: false,
  updatingProjectPreviewPassword: false,
  mostRecentActivityLogUpdate: null,
  mostRecentActivityLogType: null,
  isProjectDuplicating: false,
  workingSession: null,
  loadingWorkingSession: false,
  duplicatedSession: null,
  duplicatedProject: null,
  greenroomSessionMeetings: {},
  greenroomMeeting: null,
  greenroomMeetingError: false,
  greenroomMeetingLoading: false,
  greenroomMeetingLoadingUuid: undefined,
  greenroomShots: null,
  greenroomShotsLoading: false,
  greenroomShotsError: false,
  greenroomMedia: null,
  greenroomMediaLoading: false,
  greenroomMediaError: false,
  greenroomGraphics: null,
  greenroomGraphicsLoading: false,
  greenroomGraphicsError: false,
  sessionEngagementTotals: null,
  loadingSessionEngagementTotals: false,
  showAnnouncementsModal: false,
  publishStatusKnown: false,
  liveSessionUuid: undefined,
  isSessionLive: false,
  sessionLiveStartAtMilliSec: null,
  liveStateRequestId: undefined,
};
